<template>
  <div>
    <!-- 작업기간 -->
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>작업기간</span></label>
      <div class="col-6 pt-2">
        <DatePicker class="form-control" type="date" range :append-to-body="true"
          v-model="permit.workPeriod"
          :clearable="false" :editable="false"
          :disabled-date="scheduleDateDisabledFn"
          style="font-size: 12px;"
          input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>

    <!-- 운전원 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>운전원</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md light-blue" @click="permit.operators.push({ name: '', license: '', phone: '' })">
            <i class="icon-plus mr-5"></i>행 추가
          </button>
          <button class="btn btn-md line-2" @click="$emit('load-operators')">
            <i class="icon-refresh mr-5"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <table class="tbl select-tbl">
          <colgroup><col><col><col><col style="width:80px;"></colgroup>
          <thead class="no-drag">
            <tr><th>성명</th><th>면허</th><th>연락처</th><th></th></tr>
          </thead>
          <tbody>
            <tr v-for="(op, idx) in permit.operators" :key="idx">
              <td><input type="text" class="form-control" v-model="op.name" placeholder="성명"></td>
              <td><input type="text" class="form-control" v-model="op.license" placeholder="면허종류"></td>
              <td><input type="text" class="form-control" v-model="op.phone" placeholder="연락처"></td>
              <td style="text-align:center;">
                <button class="btn btn-xs line-2" @click="permit.operators.splice(idx,1)" :disabled="permit.operators.length === 1">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 유도자 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>유도자</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md light-blue" @click="permit.guides.push({ name: '', signalMethods: [], phone: '', wirelessMeans: '' })">
            <i class="icon-plus mr-5"></i>행 추가
          </button>
          <button class="btn btn-md line-2" @click="$emit('load-guides')">
            <i class="icon-refresh mr-5"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <table class="tbl select-tbl">
          <colgroup><col><col><col><col style="width:80px;"></colgroup>
          <thead class="no-drag">
            <tr><th>성명</th><th>신호방법</th><th>연락처</th><th></th></tr>
          </thead>
          <tbody>
            <tr v-for="(guide, idx) in permit.guides" :key="idx">
              <td><input type="text" class="form-control" v-model="guide.name" placeholder="성명"></td>
              <td style="vertical-align:middle;">
                <label class="md-check mr-20"><input type="checkbox" v-model="guide.signalMethods" value="수신호"><i class="blue"></i>수신호</label>
                <label class="md-check"><input type="checkbox" v-model="guide.signalMethods" value="무선"><i class="blue"></i>무선</label>
                <input v-if="guide.signalMethods && guide.signalMethods.includes('무선')" type="text" class="form-control mt-5" v-model="guide.wirelessMeans" placeholder="무선수단 입력 (예: 무전기/채널)">
              </td>
              <td><input type="text" class="form-control" v-model="guide.phone" placeholder="연락처"></td>
              <td style="text-align:center;">
                <button class="btn btn-xs line-2" @click="permit.guides.splice(idx,1)" :disabled="permit.guides.length === 1">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 기계·장비 제원 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>기계·장비 제원</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md line-2" @click="$emit('load-equipment')">
            <i class="icon-refresh mr-5"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <div v-for="(equip, eIdx) in permit.equipmentList" :key="equip.id" class="box mb-10">
          <div class="box-header" style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;">
            <div style="display:flex;align-items:center;gap:16px;">
              <span style="font-weight:600;">장비 {{ eIdx + 1 }}</span>
              <span style="font-size:13px;">건설기계 등록증</span>
              <label class="md-check mr-10"><input type="radio" v-model="equip.hasCertificate" :value="true"><i class="blue"></i>유</label>
              <label class="md-check"><input type="radio" v-model="equip.hasCertificate" :value="false"><i class="blue"></i>무</label>
            </div>
            <button class="btn btn-xs line-2" @click="permit.equipmentList.splice(eIdx,1)"
              :disabled="permit.equipmentList.length === 1">삭제</button>
          </div>
          <div class="box-body">
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0"><span class="ess">제조사</span></label>
              <div class="col-4"><input type="text" class="form-control" v-model="equip.manufacturer"></div>
              <label class="col-2 form-control-label pt-0"><span class="ess">형식번호(모델)</span></label>
              <div class="col-4"><input type="text" class="form-control" v-model="equip.modelNo" placeholder="중형특수"></div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">제조 일련번호</label>
              <div class="col-4"><input type="text" class="form-control" v-model="equip.serialNo" placeholder="oo고소작업대"></div>
              <label class="col-2 form-control-label pt-0">제작연도</label>
              <div class="col-4"><input type="text" class="form-control" v-model="equip.manufactureYear"></div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0"><span class="ess">안전인증일(인증기관)</span></label>
              <div class="col-4"><input type="text" class="form-control" v-model="equip.safetyCertDate" placeholder="0000.00.00.(안전보건공단)"></div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0"><span class="ess">작업대 최대높이</span></label>
              <div class="col-4"><input type="text" class="form-control" v-model="equip.maxWorkHeight" placeholder="00 m"></div>
              <label class="col-2 form-control-label pt-0"><span class="ess">정격하중</span></label>
              <div class="col-4"><input type="text" class="form-control" v-model="equip.ratedLoad" placeholder="kg"></div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0"><span class="ess">작업대(L*W*H)</span></label>
              <div class="col-4"><input type="text" class="form-control" v-model="equip.platformSpec" placeholder="00*00*00"></div>
              <label class="col-2 form-control-label pt-0">허용탑승인원수</label>
              <div class="col-4"><input type="text" class="form-control" v-model="equip.maxOccupancy" placeholder="(명)"></div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">최대허용경사</label>
              <div class="col-4"><input type="text" class="form-control" v-model="equip.maxSlope" placeholder="좌·우=  전·후="></div>
              <label class="col-2 form-control-label pt-0">최대허용풍속</label>
              <div class="col-4"><input type="text" class="form-control" v-model="equip.maxWindSpeed" placeholder="(m/s)"></div>
            </div>
          </div>
        </div>
        <button class="btn btn-md light-blue" @click="addEquipment">
          <i class="icon-plus mr-5"></i>장비 추가
        </button>
      </div>
    </div>

    <!-- 작업장소 사전 조사 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>작업장소의 지형·지반 상태 등 사전 조사내용</span></label>
      <div class="col-10 pt-2">
        <!-- 작업장소의 지형·지반 상태 -->
        <div class="form-group row mb-10">
          <label class="col-2 form-control-label pt-0">작업장소의 지형·지반 상태</label>
          <div class="col-10">
            <div class="form-group row mb-0">
              <label class="col-2 form-control-label pt-0"><span class="ess">견고한 지반, 작업장소 경사</span></label>
              <div class="col-10">
                <div style="display:flex;flex-wrap:wrap;align-items:center;gap:8px 16px;">
                  <label class="md-check mr-15"><input type="checkbox" v-model="permit.siteInvestigation.groundConditions" value="견고하고 평탄한 지형"><i class="blue"></i>견고하고 평탄한 지형</label>
                  <label class="md-check mr-10"><input type="checkbox" v-model="permit.siteInvestigation.slopeCheck"><i class="blue"></i>경사</label>
                  <input v-if="permit.siteInvestigation.slopeCheck" type="text" class="form-control" v-model="permit.siteInvestigation.slopeText" placeholder="00°" style="width:70px;">
                </div>
                <div style="display:flex;flex-wrap:wrap;align-items:center;gap:8px 16px;margin-top:8px;">
                  <label class="md-check mr-10"><input type="checkbox" v-model="permit.siteInvestigation.specialNoteCheck"><i class="blue"></i>특이사항</label>
                  <input v-if="permit.siteInvestigation.specialNoteCheck" type="text" class="form-control" v-model="permit.siteInvestigation.specialNoteText" placeholder="특이사항 입력" style="max-width:300px;">
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 주변 작업·이동 및 지장물 간섭 -->
        <div class="form-group row mt-15 mb-0">
          <label class="col-2 form-control-label pt-0">주변 작업·이동 및 지장물 간섭</label>
          <div class="col-10">
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0"><span class="ess">작업반경 내 출입금지 조치</span></label>
              <div class="col-10">
                <label class="md-check mr-15" v-for="a in ['유도자','접근방지 로프','칼라콘']" :key="a">
                  <input type="checkbox" v-model="permit.siteInvestigation.accessRestrictions" :value="a"><i class="blue"></i>{{ a }}
                </label>
                <label class="md-check mr-10"><input type="checkbox" v-model="permit.siteInvestigation.accessRestrictionOther"><i class="blue"></i>기타</label>
                <input v-if="permit.siteInvestigation.accessRestrictionOther" type="text" class="form-control mt-5"
                       v-model="permit.siteInvestigation.accessRestrictionOtherText" placeholder="기타 조치" style="max-width:300px;">
              </div>
            </div>
            <div class="form-group row mb-0">
              <label class="col-2 form-control-label pt-0"><span class="ess">작업대 주변 등 지장물 간섭여부</span></label>
              <div class="col-10" style="display:flex;align-items:center;gap:12px;">
                <label class="md-check" style="white-space:nowrap;"><input type="radio" v-model="permit.siteInvestigation.obstacleCheck" value="있음"><i class="blue"></i>있음</label>
                <label class="md-check" style="white-space:nowrap;"><input type="radio" v-model="permit.siteInvestigation.obstacleCheck" value="없음"><i class="blue"></i>없음</label>
                <input v-if="permit.siteInvestigation.obstacleCheck === '있음'" type="text" class="form-control"
                       v-model="permit.siteInvestigation.obstacleMeasure" placeholder="조치" style="max-width:300px;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 작업순서 및 안전 작업 방법 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>작업순서 및 안전 작업 방법</span></label>
      <div class="col-10 pt-2">
        <WorkProcedureTable :procedures="permit.procedures" @load-procedures="$emit('load-procedures')" />
      </div>
    </div>

    <!-- 첨부서류 목록 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>첨부서류 목록</span></label>
      <div class="col-10 pt-2">
        <div v-for="doc in permit.attachmentDocs" :key="doc.key" class="mb-10">
          <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">
            <label class="md-check" style="min-width:220px;">
              <input type="checkbox" v-model="doc.checked"><i class="blue"></i>{{ doc.label }}<span v-if="doc.required" style="color:#eb5757;margin-left:2px;">*</span>
            </label>
            <template v-if="doc.checked">
              <input type="file" multiple :id="'scissor-doc-' + doc.key" style="display:none;"
                @change="handleDocFile($event, doc)">
              <button class="btn btn-sm line-2" @click="$el.querySelector('#scissor-doc-' + doc.key).click()"
                :disabled="doc.maskingChecking">
                <i class="icon-upload mr-3"></i>파일 선택
              </button>
              <span v-if="doc.maskingChecking" class="text-info" style="font-size:11px;">
                <i class="fa fa-spinner fa-spin mr-3"></i>AI 가 개인정보 마스킹 여부를 확인하는 중입니다... (최대 1분 소요)
              </span>
              <div v-if="doc.rejections && doc.rejections.length" class="mt-5"
                   style="width:100%; padding:8px 10px; background:#fff5f5; border:1px solid #f5c6cb; border-radius:4px; font-size:11px; color:#721c24;">
                <div v-for="(r, ri) in doc.rejections" :key="'rej-'+ri" :class="ri ? 'mt-3' : ''">
                  <strong>[{{ r.fileName }}] 업로드 거부 — 개인정보 마스킹 미흡</strong>
                  <span v-if="r.documentSubtype"> · {{ r.documentSubtype }}</span>
                  <span v-if="r.confidence != null"> · 신뢰도 {{ Math.round(r.confidence * 100) }}%</span>
                  <span v-if="r.totalCount"> · AI {{ r.totalCount }}회 중 {{ r.rejectedCount }}회 거절</span>
                  <div>· 노출된 항목 : {{ r.exposedFields.length ? r.exposedFields.join(', ') : '(미상)' }}</div>
                  <div>· AI 평가     : {{ r.overallAssessment }}</div>
                </div>
              </div>
              <div v-if="doc.maskingError" class="mt-5" style="width:100%; padding:6px 10px; background:#fff3cd; border:1px solid #ffeeba; border-radius:4px; font-size:11px; color:#856404;">
                {{ doc.maskingError }}
              </div>
              <div v-if="doc.files && doc.files.length" style="display:flex;flex-wrap:wrap;gap:4px;">
                <span v-for="(f, fi) in doc.files" :key="fi"
                  style="font-size:11px;background:#f0f0f0;padding:2px 6px;border-radius:3px;display:flex;align-items:center;gap:4px;">
                  {{ f.name }}
                  <button class="btn btn-xs line-2" style="padding:0 4px;height:16px;line-height:14px;" @click="doc.files.splice(fi,1)">×</button>
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WorkProcedureTable from './WorkProcedureTable.vue';
import docFileUploadMixin from '@/mixins/docFileUploadMixin';
export default {
  name: 'ScissorLiftPermit',
  components: { WorkProcedureTable },
  mixins: [docFileUploadMixin],
  inject: { workPermitPlanId: { default: () => '' } },
  data() { return { workPermitFormKey: 'scissorLiftPermit' }; },
  props: {
    permit: {
      type: Object,
      required: true
    },
    scheduleDateDisabledFn: {
      type: Function,
      default: () => false
    },
    signalMethodOptions: {
      type: Array,
      default: () => ['수신호', '무선', '기타']
    }
  },
  methods: {
    addEquipment() {
      this.permit.equipmentList.push({ id: Date.now(), hasCertificate: null, manufacturer: '', modelNo: '', serialNo: '', manufactureYear: '', safetyCertDate: '', maxWorkHeight: '', ratedLoad: '', platformSpec: '', maxOccupancy: '', maxSlope: '', maxWindSpeed: '' });
    },
  }
}
</script>